import { connect } from "react-redux";
import {
  fetchingAuthStatus,
  loginSuccessful,
  resetLockoutDuration,
  setTokens
} from "../../store/authentication/actions";
import {
  requestToken,
  checkAuthStatus,
  requestForgotPassword,
  requestSignUp
} from "../../store/authentication/thunks";
import { setFailureMessage } from "../../store/authentication/actions";
import Authenticate from "./Authenticate";

const mapStateToProps = state => {
  const { authentication } = state;

  return {
    isAuthenticated: authentication.isAuthenticated,
    isFetching: authentication.isFetching,
    failureMessage: authentication.failureMessage,
    lockOutDuration: authentication.lockOutDuration,
    initiatePasswordChange: authentication.initiatePasswordChange
  };
};

const mapDispatchToProps = {
  fetchingAuthStatus,
  resetLockoutDuration,
  requestToken,
  checkAuthStatus,
  requestForgotPassword,
  requestSignUp,
  setFailureMessage,
  setTokens,
  loginSuccessful
};

const AuthenticateContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Authenticate);

export default AuthenticateContainer;
